import { FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

const pageKeyMap: Record<string, string> = {
	dashboard: 'PAGES.DASHBOARD',
	'company-documents': 'PAGES.COMPANY_DOCUMENTS',
	'shareholders-registry': 'PAGES.SHAREHOLDERS_REGISTRY',
	profile: 'PAGES.PROFILE',
	actions: 'PAGES.SHAREHOLDER_INFO',
	'shareholder-info': 'PAGES.SHAREHOLDER_INFO',
	'registry-transactions': 'PAGES.REGISTRY_TRANSACTIONS',
	'heirs-transfer': 'PAGES.HEIRS_TRANSFER',
	suspend: 'PAGES.SUSPEND',
	notice: 'PAGES.NOTICE',
	announcement: 'PAGES.ANNOUNCEMENT',
	'update-documents': 'PAGES.UPDATE_DOCUMENTS',
	'financial-statement': 'PAGES.FINANCIAL_STATEMENT',
	'company-information': 'PAGES.OVERVIEW',
	overview: 'PAGES.OVERVIEW',
	'shareholders-list': 'PAGES.SHAREHOLDERS_LIST',
	'cap-table': 'PAGES.CAP_TABLE',
	'transactions-logs': 'PAGES.TRANSACTIONS_LOGS',
	payments: 'PAGES.PAYMENTS',
	'data-room': 'PAGES.DATA_ROOM',
	'users-management': 'PAGES.USERS_MANAGEMENT',
	wallet: 'PAGES.WALLET',
	assemblies: 'PAGES.ASSEMBLIES',
	attendance: 'PAGES.ASSEMBLY_ATTENDANCE',
	mortgages: 'PAGES.MORTGAGES',
	'brand-identity': 'PAGES.BRAND_IDENTITY',
	boards: 'PAGES.BOARDS',
	meetings: 'PAGES.BOARDS',
	documents: 'PAGES.BOARDS',
	'attach-members': 'PAGES.BOARDS',
	capitals: 'PAGES.CAPITALS',
	dividends: 'PAGES.DIVIDENDS',
	committees: 'PAGES.COMMITTEES',
	'loyalty-programs': 'PAGES.LOYALTY_PROGRAMS',
};

const isDynamicSegment = (segment: string): boolean => {
	// Matches numbers or UUIDs or Mongo-style ids
	return /^\d+$/.test(segment) || /^[a-f0-9-]{6,}$/.test(segment);
};

const PageName: FunctionComponent = () => {
	const { t } = useTranslation();
	const location = useLocation();
	const [pageName, setPageName] = useState<string>('');

	useEffect(() => {
		const paths = location.pathname.split('/').filter(Boolean);

		let module = paths[paths.length - 1];

		// If last path is dynamic ID, take the one before it
		if ((isDynamicSegment(module) && paths.length > 1) || paths[paths.length - 1] == 'create') {
			module = paths[paths.length - 2];
		}

		setPageName(pageKeyMap[module] || '');
	}, [location]);

	return <h6 className="text-light">{t(pageName)}</h6>;
};

export default PageName;
